import { Component } from "preact";
import queryString from "query-string";
import React from "react";
import CMSComponent from "../../components/CMSComponent";
import CallToAction from "../../components/layout/CallToAction";
import Layout from "../../components/layout/Layout";
import SeperatorDiv from "../../components/SeparatorDiv";
import { updateTitle } from "../../utils/BrowserUtils";
import Banner from "./components/Banner";
import BoardAdvisors from "./components/BoardAdvisors";
import History from "./components/History";
import TeamMembers from "./components/TeamMembers";

class OurStories extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    updateTitle("Our Stories");
    const search = typeof window !== "undefined" ? window.location.search : "";
    const parsed = queryString.parse(search);
    if (parsed && parsed.l) {
      document.getElementById(parsed.l).scrollIntoView();
    }
  }

  render() {
    const { locale } = this.props;
    return (
      <Layout>
        <Banner />
        <History />
        {locale === "au" ? <BoardAdvisors /> : null}
        <TeamMembers locale={locale} />
        <CallToAction
          text="Want to join our team? Check out our job openings."
          buttonText="See careers"
          link={"https://angel.co/humanitix"}
        />
      </Layout>
    );
  }
}

export default CMSComponent(null, OurStories);
